import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends BridgeComponent {
  static component = "barcode-scanner"

  scan() {
    this.send("scan", {}, (message) => {
      const barcode = message.data?.barcode
      if (!barcode) return

      const url = `${window.location.origin}/historial/${encodeURIComponent(barcode)}`
      Turbo.visit(url, { action: "advance" })
    })
  }
}
